export default "__VITE_ASSET__CezbN6Ar__"